import { registerIndicator } from 'klinecharts';

registerIndicator({
  name: 'EMA',
  shortName: 'EMA',
  calcParams: [20],
  figures: [
    { key: 'ema', title: 'EMA: ', type: 'line' }
  ],
  calc: (dataList, indicator) => {
    const period = indicator.calcParams[0];
    const alpha = 2 / (period + 1);
    let lastEma = null;
    return dataList.map(kLineData => {
      const close = kLineData.close;
      if (lastEma === null) {
        lastEma = close;
      } else {
        lastEma = alpha * close + (1 - alpha) * lastEma;
      }
      return { ema: lastEma };
    });
  }
});
